var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cart-container',{attrs:{"title":_vm.$t('createOrder.comment')}},[_c('text-input',{attrs:{"placeholder":"...","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }